// utils_perf.js — 无侵入性能优化脚本 by [WW]

// ========== 全局节流 / 防抖工具 ==========
window.ww_throttle = function (fn, wait = 100) {
  let last = 0;
  return function (...args) {
    const now = Date.now();
    if (now - last >= wait) {
      last = now;
      fn.apply(this, args);
    }
  };
};

window.ww_debounce = function (fn, delay = 300) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
};

// ========== 延迟任务工具 ==========
window.ww_idleTask = function (fn, fallback = 300) {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(fn);
  } else {
    setTimeout(fn, fallback);
  }
};

// ========== Web Worker 封装调用器 ==========
window.ww_callWorker = function (workerUrl, type, payload) {
  return new Promise((resolve, reject) => {
    const worker = new Worker(workerUrl);
    worker.onmessage = (e) => {
      if (e.data.type === `${type}_result`) {
        resolve(e.data.result);
      }
    };
    worker.onerror = reject;
    worker.postMessage({ type, payload });
  });
};

// ========== 自动劫持并节流/防抖监听器 ==========
(function () {
  const originalAddEventListener = EventTarget.prototype.addEventListener;

  // 定义自动处理的事件及对应策略
  const autoIntercept = {
    scroll: { mode: 'throttle', delay: 100 },
    resize: { mode: 'throttle', delay: 200 },
    mousemove: { mode: 'throttle', delay: 100 },
    touchmove: { mode: 'throttle', delay: 100 },
    input: { mode: 'debounce', delay: 300 },
    keyup: { mode: 'debounce', delay: 200 },
  };

  // 自动包装事件监听器
  EventTarget.prototype.addEventListener = function (type, listener, options) {
    const setting = autoIntercept[type];
    if (setting && typeof listener === 'function') {
      let wrapped = listener;
      if (setting.mode === 'throttle') {
        wrapped = window.ww_throttle(listener, setting.delay);
      } else if (setting.mode === 'debounce') {
        wrapped = window.ww_debounce(listener, setting.delay);
      }
      return originalAddEventListener.call(this, type, wrapped, options);
    }
    return originalAddEventListener.call(this, type, listener, options);
  };
})();
